import React from "react";
import {
  Button,
  Label,
  Card,
  Text,
} from "../../design";
import { translate } from "../../utils/translations";
import { DB_SUBSCRIPTION_STATUS_INPROGRESS, SUBSCRIPTION_STATUS_READABLE } from "../../utils/constants";

function NewSubscriptionCard({ contract, reloadContracts }) {
  return (
    <Card color="dark" className="my-4">
      <Card.Header>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <Text.P1 className="loop-text-muted">{"#" + contract.subscriptionContract_shopify_id}</Text.P1>
          <Label entity="subscription" dbStatus={DB_SUBSCRIPTION_STATUS_INPROGRESS} title={translate('subscription_status_' + SUBSCRIPTION_STATUS_READABLE[DB_SUBSCRIPTION_STATUS_INPROGRESS])} />
        </div>
      </Card.Header>
      <Card.Body className="p-2">
        <div className="d-flex align-items-center justify-content-between">
          <Text.P1>-</Text.P1>
          <Button onClick={reloadContracts} size="sm">{translate('subscription_listing_refresh_button')}</Button>
        </div>
      </Card.Body>
    </Card>
  );
}


export default NewSubscriptionCard;
